import { z } from 'zod';
export const verifyHumanityOutputSchema = z.object({
    userId: z.string(),
    isHuman: z.boolean(),
    reason: z.string(),
    suspiciousField: z.enum(['name', 'email', 'twitterUsername']).optional(),
});
